import { Dropdown } from "react-bootstrap";
import "./styles.css";

export default function ClientFilterDropdown ({style, clients, onSelect, selectedClient}) {
    return (
        <Dropdown style={{...style}}>
            <Dropdown.Toggle variant="dark" className="btn-sm" style={{ width: '100%'}}>
                {selectedClient ? selectedClient.name : "Todos clientes"}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: '100%', backgroundColor: '#27272A'}}>
                <Dropdown.Item
                    className="dropdown-item"
                    onClick={() => {
                        onSelect('')
                    }}
                >
                    Todos os clientes
                </Dropdown.Item>
                {clients?.map((client, index) => (
                    <Dropdown.Item
                        key={index}
                        className="dropdown-item"
                        onClick={() => {
                            onSelect(client)
                        }}
                    >
                        {client.name}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}